import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { AUTH_SERVICE_TOKEN, IAuthService } from '../models/iauth-service.model';
import { AuthActionTypes, Logout } from './actions';

@Injectable()
export class AuthEffects {
  private _actions$ = inject(Actions);
  private _authService = inject<IAuthService>(AUTH_SERVICE_TOKEN);

  userLogout$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType<Logout>(AuthActionTypes.Logout),
        mergeMap(() => this._authService.logout()),
      ),
    { dispatch: false },
  );

  constructor() {}
}
